/// <reference types="@angular/localize" />
// ✅ 1. Faro SDK imports
// import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
// import { TracingInstrumentation } from '@grafana/faro-web-tracing';

// ✅ 2. Initialize Faro BEFORE Angular bootstraps
// initializeFaro({
//   url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/b789f4db3ba15e1fb3249c0e53c7d570',
//   // url: 'http://grafana-k8s-monitoring-alloy.monitoring.svc.cluster.local:4317',
//   app: {
//     name: 'qualis-website-v1',
//     version: '1.0.0',
//     environment: 'qualis-prod',
//   },
//   trackGeolocation: true,
//   instrumentations: [
//     ...getWebInstrumentations({
//       captureConsole: true, // Capture console logs
//     }),
//     new TracingInstrumentation(), // Traces XHR/fetch requests
//   ],
// });

// // ✅ 3. Wrap console.error to format errors
// const originalConsoleError = console.error;
// console.error = (...args: any[]) => {
//   const formattedArgs = args.map((arg) => {
//     if (arg instanceof Error) {
//       return `${arg.message}\n${arg.stack || 'No stack trace'}`;
//     }
//     if (typeof arg === 'object') {
//       try {
//         return JSON.stringify(arg, null, 2);
//       } catch {
//         return String(arg);
//       }
//     }
//     return arg;
//   });
//   originalConsoleError.apply(console, formattedArgs);
// };

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
